import { Component, OnInit } from '@angular/core';
import { GlobalVariable } from '../global';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.page.html',
  styleUrls: ['./wallet.page.scss'],
})
export class WalletPage implements OnInit {
  walletCategoriesList=[]

  constructor(public server:UserApiService,
    public globals:GlobalVariable,
    ) { }

  ngOnInit() {
    this.WalletCategories();
  }
  WalletCategories() {

  
    let response = this.server.GetWalletCategories();

    response.subscribe(data => {
        this.walletCategoriesList = data;
      
        console.log(this.walletCategoriesList);
    }, error => {
        console.log(error)
    });


}
}
